import { useAuth } from '../../../../utils/Auth';
import styles from './Shape.module.css';

export default function Shape() {

    const { qr_options, optionsDispatch } = useAuth();

    const handleShapeChange = (e) => {
        const id = e.target.id;
        if (id === 'square') {
            optionsDispatch({type: 'shape', options: 'square'});
        } else if (id === 'circle') {
            optionsDispatch({type: 'shape', options: 'circle'});
        } else {
            return;
        };
    };

    return (
        <div className={styles.container}>
            <div className={styles.label}>Shape</div>
            <div className={styles.containerInner}>
                <label htmlFor='square' className={styles.radioBtn}>
                    Square
                    <div className={styles.squareWrap}>
                        <img src='/images/square.svg' className={styles.square} alt='qr square' />
                    </div>
                    <input type='radio' id='square' className={styles.radio} checked={qr_options?.shape === 'square'} onChange={handleShapeChange} />
                </label>
                <label htmlFor='circle' className={styles.radioBtn}>
                    Circle
                    <div className={styles.circleWrap}>
                        <img src='/images/circle.svg' className={styles.circle} alt='qr circle' />
                    </div>
                    <input type='radio' id='circle' className={styles.radio} checked={qr_options?.shape === 'circle'} onChange={handleShapeChange} />
                </label>
            </div>
        </div>
    );
};